
import { supabase } from '@/integrations/supabase/client';
import { toast } from 'sonner';
import { ConsumptionRecord } from './types';

export const markRecipeAsConsumed = async (profileId: string, recipeId: string): Promise<boolean> => {
  try {
    const { error: consumptionError } = await supabase
      .from('food_consumption')
      .insert({
        profile_id: profileId,
        recipe_id: recipeId
      });
      
    if (consumptionError) throw consumptionError;
    
    const { data: existingPoints, error: fetchError } = await supabase
      .from('health_points')
      .select('*')
      .eq('profile_id', profileId)
      .maybeSingle();
      
    if (fetchError) throw fetchError;
    
    if (existingPoints) {
      const { error: updateError } = await supabase
        .from('health_points')
        .update({ 
          total_points: existingPoints.total_points + 1,
          last_updated: new Date().toISOString()
        })
        .eq('profile_id', profileId);
        
      if (updateError) throw updateError;
    } else {
      const { error: insertError } = await supabase
        .from('health_points')
        .insert({
          profile_id: profileId,
          total_points: 1
        });
        
      if (insertError) throw insertError;
    }
    
    toast.success('¡Has ganado 1 punto de salud!');
    return true;
  } catch (error) {
    console.error('Error al marcar receta como consumida:', error);
    toast.error('Error al actualizar tus puntos de salud');
    return false;
  }
};

export const hasConsumedRecipeToday = async (profileId: string, recipeId: string): Promise<boolean> => {
  try {
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    
    const { data, error } = await supabase
      .from('food_consumption')
      .select('*')
      .eq('profile_id', profileId)
      .eq('recipe_id', recipeId)
      .gte('consumed_at', today.toISOString())
      .returns<any[]>();
      
    if (error) throw error;
    return (data || []).length > 0;
  } catch (error) {
    console.error('Error al verificar consumo de receta:', error);
    return false;
  }
};

export const getFoodConsumptionHistory = async (profileId: string): Promise<ConsumptionRecord[]> => {
  try {
    if (!profileId) return [];
    
    const { data, error } = await supabase
      .from('food_consumption')
      .select(`
        *,
        recipe:recipe_id(name)
      `)
      .eq('profile_id', profileId)
      .order('consumed_at', { ascending: false })
      .returns<any[]>();
      
    if (error) {
      console.error('Error fetching consumption history:', error);
      throw error;
    }
    
    return (data || []).map(item => ({
      id: item.id,
      profile_id: item.profile_id,
      recipe_id: item.recipe_id,
      recipe_name: item.recipe?.name || 'Receta desconocida',
      consumed_at: item.consumed_at,
      points: item.points || 1
    }));
  } catch (error) {
    console.error('Error al obtener historial de consumo:', error);
    return [];
  }
};
